// A'gong Durian Showcase — scroll-triggered entrance animations
document.addEventListener('DOMContentLoaded', function () {
  var showcases = document.querySelectorAll('[data-agong-showcase]');
  if (!showcases.length) return;

  // Use IntersectionObserver for scroll-triggered fade-in
  if (!window.IntersectionObserver) {
    // Fallback: just show everything immediately
    document.querySelectorAll('[data-agong-animate], .agong-showcase__card').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  // Observe header
  document.querySelectorAll('[data-agong-animate]').forEach(function (el) {
    observer.observe(el);
  });

  // Observe each card
  document.querySelectorAll('[data-agong-cards] .agong-showcase__card').forEach(function (el) {
    observer.observe(el);
  });
});
